import JournalEditor from "@/components/JournalEditor";
import JournalFilters from "@/components/JournalFilters";
import MemoView from "@/components/JournalView/JournalView";
import { MemoRenderContext } from "@/components/MasonryView";
import PagedMemoList from "@/components/PagedJournalList";
import { useMemoFilters, useMemoSorting } from "@/hooks";
import { State } from "@/types/proto/api/v1/common_pb";
import { Memo } from "@/types/proto/api/v1/memo_service_pb";
import { useTranslate } from "@/utils/i18n";

const Home = () => {
  const t = useTranslate();

  // Track props changes
  const memoFilter = useMemoFilters({
    includeShortcuts: true,
    includePinned: true,
  });

  const { listSort, orderBy } = useMemoSorting({
    pinnedFirst: true,
    state: State.NORMAL,
  });

  return (
    <div className="w-full min-h-full bg-background text-foreground">
      {/* Journal Editor and Filters - rendered independently to avoid re-renders when filter changes */}
      {/* Apply same width constraints as MasonryColumn (max-w-2xl + centering) */}
      <div className="mx-auto w-full max-w-2xl flex flex-col">
        <JournalEditor className="mb-2" cacheKey="home-journal-editor" placeholder={t("editor.any-thoughts")} />
        <JournalFilters />
      </div>

      {/* Main memo list */}
      <PagedMemoList
        renderer={(memo: Memo, context?: MemoRenderContext) => (
          <MemoView key={`${memo.name}-${memo.displayTime}`} memo={memo} showPinned compact={context?.compact} />
        )}
        listSort={listSort}
        orderBy={orderBy}
        filter={memoFilter}
        includeAiAnalysis={true}
        hideEditor={true}
        hideFilters={true}
      />
    </div>
  );
};

export default Home;
